import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import props from '../../../lib/contentLayoutProps/admissions/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="zh" pageKey="admissions-enquiry">
    <h1>入學查詢</h1>
    <p>
      家長為子女選擇學校是一個非常重大的決定。我們很高興您會選擇京斯敦國際學校。我們十分樂意解答您對本校的任何查詢。
    </p>
    <p>
      瀏覽本校網頁。本校網頁提供了很多有用資訊供家長參考。我們鼓勵家長參與本校的校園導賞團。我們定期(每個月第一個星期三)舉辦校園導賞團，幼稚園導賞團於當天早上九時十五分開始，小學導賞團則於上午十時十五分開始，由學校領導層帶領各位參觀各校舍。家長可藉此機會深入了解本校。
    </p>
    <p>家長可參加本校每年十一月週六舉辦的開放日。屆時，我們會於網站公佈開放日的詳情。</p>
    <p>歡迎致電2337 9031 或電郵至enquiry@kingston.edu.hk與本校校務處職員聯絡。</p>
  </ContentLayout>
);
